skrilla.controller('createSeasonCtrl', function ($scope, searchService, modalService, cacheService, srefService, dateService, dataService) {
    function dismiss(){
        modalService.dismissAll();
    }
    $scope.sport = cacheService.getObjectOrElse("sport", dismiss)
    $scope.tournamentId = cacheService.getObjectOrElse("tournamentId", dismiss)
    $scope.validate = {}
    $scope.season = {tournamentId: $scope.tournamentId, sport: $scope.sport}

    $scope.save = function() {
        $scope.season.startDate = new Date(dateService.compensateForTimezone($scope.startDate))
        $scope.season.endDate = new Date(dateService.compensateForTimezone($scope.endDate))
        $scope.season.year = $scope.season.startDate.getYear();
        $scope.season.sport = $scope.sport;

        if(dataService.validateSeason($scope.season, $scope.validate)) {
            modalService.confirm("Are you sure you'd like to create this season?", function () {
                searchService.post("seasons/" + $scope.sport, $scope.season, "Season Successfully created").then(function (response) {
                    srefService.go("seasonDetails", {sport: $scope.sport, id: response.data.id})
                    modalService.dismissAll();
                })
            });
        }
    }

});
